import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { Team } from '../../teams/team.interface';
import { ApiResource } from './../../../models/api-resource.interface';
import { TeamService } from './team.service';
const service = new TeamService();

export interface TeamState {
   teamsOverview?: ApiResource<Array<Team>>;
}

const TeamStore: Module<TeamState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {
      SET_TEAMS_OVERVIEW(state, teamsOverview?: ApiResource<Array<Team>>) {
         state.teamsOverview = teamsOverview;
      },
      ADD_TEAM(state, team: Team) {
         state.teamsOverview?.data.push(team);
      },
      DELETE_TEAM(state, teamId: number) {
         const index = (state.teamsOverview?.data || []).findIndex((u) => u.id === teamId);
         if (index > -1) state.teamsOverview?.data.splice(index, 1);
      },
   },
   actions: {
      async getTeams(context, payload: { tenantId: number; query?: LocationQuery }) {
         const response = await service.getTeams(payload.tenantId, payload.query);
         context.commit('SET_TEAMS_OVERVIEW', response);
         return response;
      },
      async createTeam(context, payload: { tenantId: number; team: Team }) {
         const response = await service.postTeam(payload.tenantId, payload.team);
         context.commit('ADD_TEAM', response);
         return response;
      },
      async deleteTeam(context, payload: { tenantId: number; teamId: number }) {
         const response = await service.deleteTeam(payload.tenantId, payload.teamId);
         context.commit('DELETE_TEAM', payload.teamId);
         return response;
      },
   },
};

export default TeamStore;
